import Vue from "vue";
import { dateFormatter } from "@/helpers/functions.js";
export default {
  createVirtualAccount(_, payload) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`payroll/payment-management/payments/virtual-accounts`, payload)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  getVirtualAccount({ commit }, params) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`payroll/payment-management/payments/virtual-accounts`, { params })
        .then(response => {
          commit("setVirtualAccounts", response.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  verifyAccountNumber(_, params) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`payroll/payment-management/payments/verify-account-number`, {
          params,
        })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // Get Banks API and store in state
  getBanks({ commit }) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`payroll/payment-management/payments/banks`)
        .then(response => {
          commit("setBanks", response.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // 1. Get wallet stats
  getWalletStats({ commit }) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`payroll/payment-management/wallets/stats`)
        .then(response => {
          commit("setWalletStats", response.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  getUserWalletInformation({ commit }) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`payroll/payment-management/wallets`)
        .then(response => {
          commit("setUserWalletInformation", response.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // 2. Get payin transactions
  getPayinTransactions(_, params) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`payroll/payment-management/wallets/payins`, { params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // 3. Get all payout transfers
  getPayoutTransfers(_, params) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`payroll/payment-management/wallets/transfers`, { params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  getAuditTrailLogs({ commit, state }) {
    const params = {
      module: "payroll",
      page: state.auditTrailCurrentPage,
      per_page: state.auditTrailPerPage,
      ...(state.auditTrailSubModule != "" && {
        sub_module: state.auditTrailSubModule,
      }),
      ...(state.auditTrailCauserId && {
        causer_id: state.auditTrailCauserId,
      }),
      ...(state.auditTrailStartDate && {
        start_date: state.auditTrailStartDate,
      }),
      ...(state.auditTrailEndDate && {
        end_date: state.auditTrailEndDate,
      }),
    };
    commit("setAuditTrailTableLoading", true);
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`audit-trail/logs`, { params })
        .then(response => {
          const responseData = response.data || {};
          const results = responseData.results || responseData.data || [];
          const formattedResults = results.map(item => ({
            ...item,
            initiator_name:
              (item.causer_details && item.causer_details.name) ||
              `User #${item.causer_id || "--"}`,
            logged_date:
              item.readable_date ||
              (item.created_at ? dateFormatter(item.created_at, true) : "--"),
          }));

          commit("setAuditTrailLogs", formattedResults);
          commit(
            "setAuditTrailTotal",
            Number(responseData.total || responseData.count || 0)
          );
          commit("setAuditTrailTableLoading", false);
          resolve(response);
        })
        .catch(error => {
          commit("setAuditTrailTableLoading", false);
          reject(error);
        });
    });
  },
  handleAuditTrailSizeChange({ commit, dispatch }, perPage) {
    commit("setAuditTrailPerPage", perPage);
    commit("setAuditTrailCurrentPage", 1);
    dispatch("getAuditTrailLogs");
  },
  handleAuditTrailCurrentChange({ commit, dispatch }, page) {
    commit("setAuditTrailCurrentPage", page);
    dispatch("getAuditTrailLogs");
  },
};
